export const dayAbbr = (length = 3) => (day) => day.substring(0, Math.max(Math.min(length, 3), 2))
